/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const STATS_TOOLTIPS_IDS = {
    6: 'stats_tooltip_id_6',
    8: 'stats_tooltip_id_8',
    10: 'stats_tooltip_id_10',
}

export const STATS_TOOLTIP_NO_STATS = level => (
    <FormattedMessage
        id='stats_tooltip.no_stats'
        defaultMessage='Клан не проводил сражения на {level} дивизионе'
        values={{ level }}
    />
)

export const STATS_TOOLTIP_HEADER = level => (
    <FormattedMessage
        id='stats_tooltip.header'
        defaultMessage='Сражения на {level} уровне'
        values={{ level }}
    />
)



// WEBPACK FOOTER //
// ./containers/Stronghold/components/StatsTooltip/constants.jsx